import { render, staticRenderFns } from "./MachineUpgrade.vue?vue&type=template&id=04b372a6&scoped=true"
import script from "./MachineUpgrade.vue?vue&type=script&lang=js"
export * from "./MachineUpgrade.vue?vue&type=script&lang=js"
import style0 from "./MachineUpgrade.vue?vue&type=style&index=0&id=04b372a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b372a6",
  null
  
)

export default component.exports